module.exports = __webpack_public_path__ + "static/media/title_visit.f6c20f30.svg";